"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _queryString = _interopRequireDefault(require("query-string"));

var _MobileDefaultBar = _interopRequireDefault(require("./MobileDefaultBar"));

var _MobileSearchBar = _interopRequireDefault(require("./MobileSearchBar"));

var _headerContext = require("./headerContext");

var _mobileStyles = _interopRequireDefault(require("./mobileStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getUrlQuery() {
  if (window.location.search && window.location.search.includes('query=')) {
    var searchTerm = _queryString.default.parse(window.location.search).query;

    return searchTerm;
  }

  return null;
}

var MobileTopContent = /*#__PURE__*/function (_Component) {
  _inherits(MobileTopContent, _Component);

  var _super = _createSuper(MobileTopContent);

  function MobileTopContent() {
    var _this;

    _classCallCheck(this, MobileTopContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "setBarFromHistory", function (evt, state, actions) {
      evt.preventDefault();
      evt.stopPropagation();
      var searchTerm = getUrlQuery();
      return state.fromHome ? actions.clickLogo() : actions.submitSearch(searchTerm);
    });

    _defineProperty(_assertThisInitialized(_this), "renderTopBar", function (state, actions) {
      if (state.initial) {
        return _this.defaultBar();
      }

      if (state.final) {
        return _this.showResultsBar();
      }

      return _this.modalSearchBar(state, actions);
    });

    _defineProperty(_assertThisInitialized(_this), "defaultBar", function () {
      var _this$props = _this.props,
          username = _this$props.username,
          email = _this$props.email,
          onClickHome = _this$props.onClickHome,
          menuItems = _this$props.menuItems,
          hiddenMenu = _this$props.hiddenMenu,
          logo = _this$props.logo,
          logoImg = _this$props.logoImg,
          navigateMenu = _this$props.navigateMenu,
          drawerItems = _this$props.drawerItems,
          isFullHeight = _this$props.isFullHeight;
      return /*#__PURE__*/_react.default.createElement(_MobileDefaultBar.default, {
        username: username,
        email: email,
        onClickHome: onClickHome,
        menuItems: menuItems,
        hiddenMenu: hiddenMenu,
        logo: logo,
        logoImg: logoImg,
        navigateMenu: navigateMenu,
        drawerItems: drawerItems,
        isFullHeight: isFullHeight
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showResultsBar", function () {
      var _this$props2 = _this.props,
          searchCallback = _this$props2.searchCallback,
          searchPlaceHolder = _this$props2.searchPlaceHolder;
      return /*#__PURE__*/_react.default.createElement(_MobileSearchBar.default, {
        searchCallback: searchCallback,
        searchPlaceHolder: searchPlaceHolder
      });
    });

    _defineProperty(_assertThisInitialized(_this), "modalSearchBar", function (state, actions) {
      var _this$props3 = _this.props,
          searchCallback = _this$props3.searchCallback,
          searchPlaceHolder = _this$props3.searchPlaceHolder;
      var classes = (0, _mobileStyles.default)();
      return /*#__PURE__*/_react.default.createElement(_core.Modal, {
        open: state.searching,
        onClose: state.fromHome ? actions.clickLogo : actions.backToSearchResult,
        id: "sui-search-modal",
        "aria-labelledby": "sui-search-modal",
        "aria-describedby": "sui-search-modal-mobile",
        className: classes.backdrop
      }, /*#__PURE__*/_react.default.createElement(_MobileSearchBar.default, {
        searchCallback: searchCallback,
        searchPlaceHolder: searchPlaceHolder
      }));
    });

    return _this;
  }

  _createClass(MobileTopContent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement(_headerContext.HeaderContext.Consumer, null, function (_ref) {
        var state = _ref.state,
            actions = _ref.actions;

        window.onpopstate = function (evt) {
          return _this2.setBarFromHistory(evt, state, actions);
        };

        var searchTerm = getUrlQuery();

        if (state.initial && searchTerm !== null) {
          actions.submitSearch(searchTerm);
          return null;
        }

        return _this2.renderTopBar(state, actions);
      });
    }
  }]);

  return MobileTopContent;
}(_react.Component);

MobileTopContent.propTypes = {
  username: _propTypes.default.string.isRequired,
  email: _propTypes.default.string.isRequired,
  onClickHome: _propTypes.default.func.isRequired,
  searchCallback: _propTypes.default.func.isRequired,
  searchPlaceHolder: _propTypes.default.string.isRequired,
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  })).isRequired,
  drawerItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired),
  hiddenMenu: _propTypes.default.bool,
  logo: _propTypes.default.element,
  navigateMenu: _propTypes.default.bool,
  logoImg: _propTypes.default.node,
  isFullHeight: _propTypes.default.bool
};
MobileTopContent.defaultProps = {
  hiddenMenu: false,
  navigateMenu: false,
  drawerItems: null,
  logo: null,
  logoImg: null,
  isFullHeight: false
};
var _default = MobileTopContent;
exports.default = _default;